export function formatEmail(email: string): string {
  return email
    .toLowerCase()
    .trim()
    .replace(/[^\w\s@.+-]/g, '');
}
